import script from "./UnitProfileCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UnitProfileCard.vue?vue&type=script&setup=true&lang=js"

import "./UnitProfileCard.vue?vue&type=style&index=0&id=6c882fb9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c882fb9"]])

export default __exports__